import React, { useState } from "react";
import { css } from "@emotion/react";

import { styles } from "./shared-styles";
import { RelatedArticleSetTop } from "./subcomponents/RelatedArticleSetTop";
import { RelatedArticleSetBottom } from "./subcomponents/RelatedArticleSetBottom";
import { RelatedArticleSetLeftBox } from "./subcomponents/RelatedArticleSetLeftBox";
import { RelatedArticleSetRightBox } from "./subcomponents/RelatedArticleSetRightBox";
import { CSS_MQ } from "../../styles/breakpoints";
import { ContentfulComponentCMSHook } from "@swo/shared";
import { getComponentCMSClassname } from "../cms/edit-overlay/component-hook-class";
import { urlWithTagClicked } from "@swo/shared";
import { ComponentRelatedArticleType } from "@swo/storefront";

export type RelatedArticleSetComponentRightBoxProps = Omit<ComponentRelatedArticleType["right"], "tags"> & {
  tags: Array<{ link: { pathname: string; search: string | undefined }; label: string }>;
};

export const RelatedArticleSetComponent: React.FC<ComponentRelatedArticleType & ContentfulComponentCMSHook> = props => {
  // Assumption is that `props.left.link` is link to stories overview
  // This is current implementation.

  const rightElementWithExpandedLinks: RelatedArticleSetComponentRightBoxProps = {
    ...props.right,
    tags: props.right.tags.map(tag => {
      return {
        link: urlWithTagClicked(props.left.link, "", tag.link, false),
        label: tag.label,
      };
    }),
  };

  return (
    <div
      className={getComponentCMSClassname(props?.sys?.id)}
      css={css`
        max-width: var(--max-content-width-new);
        width: 100%;

        margin-left: auto;
        margin-right: auto;

        display: flex;
        flex-direction: column;
        align-items: center;
      `}
    >
      <RelatedArticleSetTop seoHeadline={props.descriptiveHeadline} emoHeadline={props.emoHeadline} />

      <div
        css={css`
          display: grid;
          width: 100%;
          grid-auto-flow: row;

          grid-column-gap: 4px;

          ${CSS_MQ.atLeastMd} {
            grid-auto-flow: column;
            grid-template-columns: repeat(2, 1fr);
          }

          ${CSS_MQ.atLeastLg} {
            min-height: 300px;
          }
        `}
      >
        <RelatedArticleSetLeftBox {...props.left} />
        <RelatedArticleSetRightBox {...rightElementWithExpandedLinks} />
      </div>

      {props.bottom && (
        <div
          css={css`
            ${styles}

            margin-top: 50px;
          `}
        >
          <RelatedArticleSetBottom {...props.bottom} />
        </div>
      )}
    </div>
  );
};
